import { GzCustomTemplateListView } from '../view/GzCustomTemplateListView';
import { templateGzCustomTemplateList } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import { GzCustomTemplateListWebComponent } from '..';
import { CustomTemplateListRequest, CustomTemplateListResponse, CustomTemplateListViewData } from '../types';
import { GridEvents } from '../../../grid/types/common';

export class GzCustomTemplateListController extends BaseWebComponentController {
  public component: GzCustomTemplateListWebComponent;
  public view: GzCustomTemplateListView;
  public viewConstructor: typeof GzCustomTemplateListView;

  private pageNumber = 0;
  private itemsTotal = 0;

  constructor(component: GzCustomTemplateListWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: GzCustomTemplateListView,
      viewTemplate: templateGzCustomTemplateList,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$pagination,
        event: GridEvents.LOAD_FIRST_PAGE,
        callback: this.handleLoadFirstPage,
      },
      {
        element: this.view.dom.$pagination,
        event: GridEvents.LOAD_PREVIOUS_PAGE,
        callback: this.handleLoadPreviousPage,
      },
      {
        element: this.view.dom.$pagination,
        event: GridEvents.LOAD_NEXT_PAGE,
        callback: this.handleLoadNextPage,
      },
      {
        element: this.view.dom.$pagination,
        event: GridEvents.LOAD_LAST_PAGE,
        callback: this.handleLoadLastPage,
      },
      {
        element: this.view.dom.$pagination,
        event: GridEvents.SET_PAGE_NUMBER,
        callback: this.handleSetPageNumber,
      },
      {
        element: this.view.dom.$pagination,
        event: GridEvents.SET_PAGE_SIZE,
        callback: this.handleSetPageSize,
      },
    ];
  }

  private async handleLoadFirstPage() {
    this.pageNumber = 0;
    await this.render();
  }

  private async handleLoadPreviousPage() {
    this.pageNumber -= 1;
    await this.render();
  }

  private async handleLoadNextPage() {
    this.pageNumber += 1;
    await this.render();
  }

  private async handleLoadLastPage() {
    this.pageNumber = Math.ceil(this.itemsTotal / this.component.pageSize) - 1;
    await this.render();
  }

  private async handleSetPageNumber(event: WebComponentEvent) {
    this.pageNumber = event.detail.pageNumber - 1;
    await this.render();
  }

  private async handleSetPageSize(event: WebComponentEvent) {
    this.component.pageSize = event.detail.pageSize;
    this.pageNumber = 0;
    await this.render();
  }

  private getItems(): Promise<CustomTemplateListResponse> {
    const request: CustomTemplateListRequest = {
      filters: this.component.filters,
      pageSize: this.component.pageSize,
      pageNumber: this.pageNumber + 1,
    };
    return this.component.dataProvider.getItems(request);
  }

  async getDataForView(): Promise<CustomTemplateListViewData> {
    this.view.setLoadingState();
    const response = await this.getItems();
    this.itemsTotal = response.itemsTotal;
    this.view.removeLoadingState();

    return {
      ...response,
      itemRenderer: this.component.itemRenderer,
      gap: this.component.gap,
      columns: this.component.columns,
      pageSize: this.component.pageSize,
      pageNumber: this.pageNumber,
      pageSizeOptions: this.component.pageSizeOptions,
    };
  }
}
